import React from "react";
import { Link } from "react-router-dom";
import { Coffee } from "lucide-react";
import { BRAND } from "@/constants/brand";

/**
 * Lighthearted "buy me a coffee" support block (Ko-fi).
 * The primary button opens ko-fi.com/cohnect in a new tab; no payments or
 * email capture happen on the Cohnect site itself.
 */
export const SupportCohnect = () => (
  <section id="support" data-testid="support-section" className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-4 scroll-mt-20">
    <div className="nb-box p-6 sm:p-8">
      <div className="grid gap-8 md:grid-cols-[1.1fr,0.9fr] items-center">
        <div>
          <div className="kicker inline-flex items-center gap-2"><Coffee className="h-3.5 w-3.5" /> Support Cohnect</div>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl font-extrabold tracking-tight leading-tight text-[color:var(--coh-ink)]">
            Like Cohnect? Buy a coffee.
          </h2>
          <p className="mt-4 text-base sm:text-lg text-[color:var(--coh-ink-muted)] leading-relaxed max-w-xl">
            Cohnect is free — the app and the weekly letter, always. If it’s helped you feel a little
            more connected, a tip on Ko-fi is a simple way to show your support and help fuel future
            updates, ideas, and improvements.
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <a
              href={BRAND.kofiUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="support-kofi-button"
              className="btn-nb btn-nb-primary inline-flex h-12 items-center px-6 font-semibold"
            >
              <Coffee className="h-5 w-5 mr-2" /> Support on Ko-fi <span aria-hidden="true" className="font-mono ml-1">↗</span>
            </a>
            <Link
              to="/support"
              data-testid="support-learnmore-link"
              className="text-sm font-semibold text-[color:var(--coh-blue)] underline underline-offset-4 decoration-2 hover:decoration-[3px]"
            >
              More ways to support <span aria-hidden="true" className="font-mono">→</span>
            </Link>
          </div>
        </div>
        <a
          href={BRAND.kofiUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Support Cohnect on Ko-fi"
          className="block border-2 border-[color:var(--coh-ink)] shadow-nb overflow-hidden transition-[transform,box-shadow] duration-200 hover:-translate-x-0.5 hover:-translate-y-0.5 hover:shadow-nb-hover"
        >
          <img src="/brand/kofi-card.jpg" alt="Support Cohnect on ko-fi.com/cohnect" className="block w-full h-auto" />
        </a>
      </div>
    </div>
  </section>
);
